// index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { store } from './store/gameStore';
import './index.css';
import App from './App';


// Configuration globale pour les erreurs
const handleGlobalError = (event: ErrorEvent) => {
  console.error('Global error:', event.error);
  event.preventDefault();
};

// Configuration pour les rejets de promesses non gérés
const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
  console.error('Unhandled promise rejection:', event.reason);
  event.preventDefault();
};

// Ajout des gestionnaires d'événements
window.addEventListener('error', handleGlobalError);
window.addEventListener('unhandledrejection', handleUnhandledRejection);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Rendu avec gestion d'erreur
try {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
        {process.env.NODE_ENV === 'production' && <Analytics />}
      </BrowserRouter>
    </Provider>
  );
} catch (error) {
  console.error('Render error:', error);
  root.render(
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-xl font-bold mb-2">Une erreur est survenue</h1>
        <button 
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-blue-500 text-white rounded-lg"
        >
          Recharger l'application
        </button>
      </div>
    </div>
  );
}
